module.exports = __webpack_public_path__ + "fonts/Inter-300-cyrillic16.de93fdc.woff2";